export default __webpack_public_path__ + "static/media/Interactive Map.9b418430.svg";